module.exports = __webpack_public_path__ + "static/media/tools.ff3df03b.svg";